<template>
  <v-container fill-height fluid>
    <v-layout text-xs-center align-center justify-center>
      <v-flex>
        <img src="@/assets/logo.png" alt="Gritus">
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {}
</script>

<style>

</style>
